module.exports = __webpack_public_path__ + "img/slash-square.41b13662.svg";